import { AttachmentType } from "@/modules/beneficiary/common/enum";

interface Props {
  t: (key: string) => string;
}

export const getAttachmentTypeOptions = ({ t }: Props) => [
  {
    label: t("general.account"),
    value: AttachmentType.Account,
  },
  {
    label: t("general.card"),
    value: AttachmentType.Card,
  }
];
